import React, { useState } from 'react';
import useCategories from 'sdk/hooks/useCategories';
import styles from './CategoriesSelect.module.scss';
import Select, { OptionType } from '../Select';

function CategoriesFilter({
  onChange, disabledNfts,
}: {
  onChange: (v: number | string | null) => void,
  disabledNfts?: boolean
}) {
  const categoriesData = useCategories()
  const categories = disabledNfts
    ? categoriesData?.data?.filter((c: any) => c.isNFT !== false) ?? [] : categoriesData?.data ?? []

  const options = [{ name: 'All' }, ...categories].map((item) => {
    const option: OptionType = { value: item.name, label: item.name }
    return option
  })
  const [order, setOrder] = useState<OptionType>(options[0])

  return (
    <div className={styles.container}>
      <Select
        options={options}
        value={order}
        onChange={(item) => {
          setOrder(item)
          const index = options.indexOf(item)
          onChange(categories?.[index - 1]?.id)
        }}
      />
    </div>
  )
}

export default CategoriesFilter
